import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=1a3640d0&scoped=true&"
import script from "./Page2.vue?vue&type=script&lang=js&"
export * from "./Page2.vue?vue&type=script&lang=js&"
import style0 from "./Page2.vue?vue&type=style&index=0&id=1a3640d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3640d0",
  null
  
)

export default component.exports